// routes/UserRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ManageAccounts from '../components/Users/ManageAccounts/ManageAccounts';
import { AccountListProvider } from '../context/AccountListContext';

export const manageAccountsRoute = (
  <Route path="/manage_accounts" element={<MainLayout />} >
    
    <Route path="" >
      <Route index element={
        <AccountListProvider>
          <ManageAccounts />
        </AccountListProvider>
      } />
    </Route>
  </Route>
);
